/**
 * Horizontal padding (MUI spacing units) applied to the main content area in {@link Layout}.
 * Pages that need to break out of this padding (e.g. a flush-left panel) can offset by the negative
 * of this value so they stay in sync if the layout padding ever changes.
 */
export const MAIN_CONTENT_PADDING_X = 3;
